import { useEffect, useRef } from "react";

export const useOutsideClick = (callback: (ranges: any) => void, ranges: any) => {
  const ref = useRef<any>();

  useEffect(() => {
    const handleClick = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback(ranges);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [ref, ranges]);

  return ref;
};
